var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { cloneElement, useRef } from 'react';
import { Card } from '../card';
import { NotificationCard } from '../notification-card';
import { ScreenReaderOnly } from '../screen-reader-only';
import { actionStyle, contentStyle, descriptionStaticStyle, notificationStyle, textContentStyle, titleStaticStyle, } from './styles';
import useInternalLayout from './use-internal-layout';
function CardInternal(_a) {
    var action = _a.action, closable = _a.closable, closeButtonOverride = _a.closeButtonOverride, description = _a.description, isVisible = _a.isVisible, mode = _a.mode, onClose = _a.onClose, size = _a.size, title = _a.title, variant = _a.variant, restProps = __rest(_a, ["action", "closable", "closeButtonOverride", "description", "isVisible", "mode", "onClose", "size", "title", "variant"]);
    var cardRef = useRef(null);
    var layout = useInternalLayout(cardRef);
    var isBannerMode = mode === 'banner';
    var isUpgrade = variant === 'upgrade';
    function renderAnnouncement() {
        switch (variant) {
            case 'success':
                return _jsx(ScreenReaderOnly, { children: "Success:" });
            case 'warning':
                return _jsx(ScreenReaderOnly, { children: "Warning:" });
            case 'error':
                return _jsx(ScreenReaderOnly, { children: "Error:" });
            default:
                return null;
        }
    }
    function renderAction() {
        if (action != null) {
            // Pass upgrade style flags
            return (_jsx(Card.Footer, __assign({ css: actionStyle({ isUpgrade: isUpgrade, layout: layout }) }, { children: cloneElement(action, {
                    isUpgrade: isUpgrade,
                    size: size,
                }) })));
        }
        return null;
    }
    return (_jsx(NotificationCard, __assign({}, {
        closable: closable,
        closeButtonOverride: closeButtonOverride,
        hideLeftDecor: isBannerMode,
        isContentCentered: isBannerMode && layout === 'horizontal',
        onClose: onClose,
        size: size,
        variant: variant,
    }, restProps, { css: notificationStyle({ isBannerMode: isBannerMode, isVisible: isVisible, variant: variant }), ref: cardRef }, { children: _jsxs("div", __assign({ css: contentStyle({ isBannerMode: isBannerMode, isUpgrade: isUpgrade, layout: layout }) }, { children: [_jsxs("div", __assign({ css: textContentStyle({ layout: layout }) }, { children: [title != null && (_jsxs(Card.Header, __assign({ as: "h2", css: titleStaticStyle, size: size }, { children: [renderAnnouncement(), title] }))), description != null && (_jsx(Card.Body, __assign({ css: descriptionStaticStyle }, { children: description })))] })), renderAction()] })) })));
}
export default CardInternal;
